import { FC } from 'react';
import { MRT_Column, MRT_Row, MRT_RowData, MRT_TableInstance } from 'material-react-table';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO } from 'date-fns';
import { StyledDatePicker, StyledTimePicker } from './pickerStyles';

interface EditCellProps {
  column: MRT_Column<MRT_RowData>;
  row: MRT_Row<MRT_RowData>;
  table: MRT_TableInstance<MRT_RowData>;
}

interface DatePickerEditProps extends EditCellProps {
  fieldKey: string;
  placeholder?: string;
}

interface TimePickerEditProps extends EditCellProps {
  fieldKey: string;
  parseTimeToDate: (time: unknown) => Date | null;
}

// Helper to handle picker value changes
const handlePickerChange = (value: unknown, row: MRT_Row<MRT_RowData>, column: MRT_Column<MRT_RowData>, table: MRT_TableInstance<MRT_RowData>) => {
  const { creatingRow, editingRow } = table.getState();
  const isCreating = creatingRow?.id === row.id;
  const isEditing = editingRow?.id === row.id;

  // eslint-disable-next-line no-underscore-dangle
  row._valuesCache[column.id] = value;

  if (isCreating) {
    table.setCreatingRow(row);
  } else if (isEditing) {
    table.setEditingRow(row);
  }
};

export const DatePickerEditCell: FC<DatePickerEditProps> = ({ column, row, table, fieldKey, placeholder = '10-Dec-2025' }) => {
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <StyledDatePicker
          defaultValue={row.original[fieldKey] ? parseISO(row.original[fieldKey]) : null}
          format='dd-MMM-yyyy'
          onChange={(value) => handlePickerChange(value, row, column, table)}
          slotProps={{
            textField: {
              placeholder,
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export const TimePickerEditCell: FC<TimePickerEditProps> = ({ column, row, table, fieldKey, parseTimeToDate }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StyledTimePicker
        defaultValue={parseTimeToDate(row.original[fieldKey])}
        ampm={false}
        views={['hours', 'minutes', 'seconds']}
        format='HH:mm:ss'
        onChange={(value) => handlePickerChange(value, row, column, table)}
        slotProps={{
          textField: {
            placeholder: 'HH:mm:ss',
            size: 'small',
            sx: { width: '100%', minWidth: '120px' },
          },
        }}
      />
    </LocalizationProvider>
  );
};
